import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Variables } from './variables';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    public environment: string;
    public init: boolean;
    public showLoading: boolean;
    public languages: Language[] = [];

    constructor(
        public http: HttpClient,
        public variables: Variables,
        public titleService: Title,
        private activeRoute: ActivatedRoute,
        @Inject('BASE_URL') public baseUrl: string) {

        const urlParams = Observable.combineLatest(
            this.activeRoute.params,
            this.activeRoute.queryParams,
            (params, queryParams) => ({ ...params, ...queryParams })
        );

        this.init = false;

        (async () => {
            this.showLoading = false;
            await this.delay(2000);
            this.showLoading = true;
        })();

        urlParams.subscribe(routeParams => {
            this.handleParameters(routeParams.l, routeParams.t);
        });
    }

    public delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    public handleParameters(language: string, token: string) {
        if (language && token) {
            this.init = true;
            this.variables.language = language;
            this.variables.token = token;

            var validLanguage = /^[a-zA-Z]+$/.test(this.variables.language) && this.variables.language;
            if (!validLanguage) {
                this.variables.language = 'en';
            }

            this.http.get<Map<string, string>>(this.baseUrl + 'api/AppSettings')
                .subscribe((result) => this.handleSettings(result),
                    error => this.handleError(error));
        } 
    }

    public handleSettings(appSettings: Map<string, string>) {
        this.variables.appSettings = appSettings;
        this.environment = this.variables.appSettings["Environment"];

        this.http.get<Map<string, string>>(this.variables.getAPIBaseURL() + 'textresource/default/' + this.variables.language)
            .subscribe((result) => this.handleDefaultTexts(result), error => console.error(error));

        if (this.languages.length == 0) {
            this.getLanguages();
        } 
    }

    public handleDefaultTexts(defaultTexts: Map<string, string>) {
        this.variables.defaultTexts = defaultTexts;
        this.titleService.setTitle(this.variables.defaultTexts['Page_Title']);
    }

    public getLanguages() {
        var scope = this;

        scope.http.get<Language[]>(scope.variables.getAPIBaseURL() + "language").subscribe(result => {
            var validLanguage = result.find(_ => _.iso_639_1 == scope.variables.language);
            if (!validLanguage) {
                this.variables.language = scope.variables.appSettings["DefaultLanguage"];
            }

            for (let language of result) {
                scope.languages.push(language);
            }
            this.init = false;
        }, error => this.handleError(error));
    }

    public handleError(error) {
        console.log(error);
        this.init = false;
    }

    public changeLanguage() {
        var url = this.variables.appSettings['BaseURL']
            .replace('[LANG]', this.variables.language)
            .replace('[TOKEN]', this.variables.token);

        window.open(url, "_self");
    }
}

class Language {
    name: string;
    iso_639_1: string;
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts